import { useAuth0 } from '@auth0/auth0-react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import "../styles/returnToDashboardButton.css";

function ReturnToDashboardButton() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth0();

  const [exitDialog, setExitDialog] = useState();
  const openExitDialog = () => setExitDialog(true);
  const closeExitDialog = () => setExitDialog(false);

  const isAuthenticatedPath = () => {
    return location.pathname === '/pendingEntries' ||
      location.pathname === '/Search' ||
      location.pathname === '/testSearch' ||
      location.pathname === '/testSearchResults' ||
      location.pathname === '/searchResults' ||
      location.pathname === '/individualPatient' ||
      location.pathname === '/individualPatientTest'
  }

  const returnToDashboard = () => {
    if (isAuthenticatedPath()) {
      logout({ logoutParams: { returnTo: window.location.origin } });
    } else {
      closeExitDialog();
      const showQualtrics = sessionStorage.getItem('showQualtrics') === 'true' ?? false;
      if (showQualtrics) {
        navigate('/qualtrics');
      } else {
        navigate('/', { replace: true });
      }
    }
  };

  return (location.pathname !== '/' && location.pathname !== '/qualtrics' &&
    <Box className="return-dashboard">
      <Button
        variant="contained"
        color="primary"
        onClick={openExitDialog}
        aria-label={t('nextsteps.exitToDashboard')}
        data-cy="global_exit_btn"
      >
        {t('dialog.exitToDashboard')}
      </Button>

      <Dialog open={exitDialog} onClose={closeExitDialog}>
        <DialogTitle>{t('dialog.title')}</DialogTitle>
        <DialogContent className="return-dashboard-dialog-content">
          {isAuthenticatedPath() ? t('dialog.bodyAdministrative') : t('dialog.body')}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeExitDialog} data-cy="cancel_btn">
            {t('common.cancel')}
          </Button>
          <Button variant="contained" onClick={returnToDashboard} data-cy="exit_btn">
            {t('common.exit')}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ReturnToDashboardButton;
